<highcharts-chart
[Highcharts]="hc"
[options]="lineChart"
style="width: 100%; height: 100%;display: block;overflow: hidden;"
>
</highcharts-chart>